export const LOGIN = '/oauth2/authorization/hscan';
